export enum ShareType {
  HEAT_PROFILE = 'HEAT_PROFILE',
  MOOD_LIGHT = 'MOOD_LIGHT',
}
